import { useDebounce } from '@aibees/shared/hooks';
import { useDeferredValue, useState } from 'react';

export function useAutocompleteSearchQuery() {
  const [searchInputValue, setSearchInputValue] = useState('');

  const debouncedSearchQuery = useDebounce(searchInputValue, 300);

  // Use deferred value to prioritize input responsiveness over filtering
  // React will update the input immediately but defer the filtering operation
  const deferredSearchQuery = useDeferredValue(debouncedSearchQuery);

  return {
    searchInputValue,
    setSearchInputValue,
    debouncedSearchQuery: deferredSearchQuery,
  };
}
